var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompareUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.689.295a.95.95 0 0 0-1.377 0L.745 3.015a.888.888 0 0 0 .058 1.28.952.952 0 0 0 1.319-.056l.945-1v5.854a.92.92 0 0 0 .934.907.92.92 0 0 0 .933-.907V3.24l.945 1.003a.954.954 0 0 0 1.319.056.89.89 0 0 0 .058-1.28L4.689.298V.295z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareUp);
export default __webpack_public_path__ + "static/media/compare-up.1e0eef590a15d3ec9f55d9f8648d2ccd.svg";
export { ForwardRef as ReactComponent };